import useGlossaryTerms from './useGlossaryTerms';

export default useGlossaryTerms;
